import React from "react";
import { Row, Button, Tooltip, Icon } from "antd";
import { downloadFile } from "../../../../components/util";

const ButtonsGroup = (props) => {
    const exportList = async (type) => {
        const REPORT_PARAMS = {
            accao: "lista",
            // lista: "config_holidays_year_to_export_as_report",
            lista: "config_holidays_year",
            // campos: "descricao:200:Designação;designacao:600:Descrição;",
            campos: "ano:24:Ano;data:24:Data de Registo;descricao:24:Descrição;",
            titulo: "Feriados",
        };

        await downloadFile("gerelistas.php", {
            ...REPORT_PARAMS,
            ...props.filter,
            saida: type,
            downloadInBrowser: true,
        });
    };
    return (
        <Row>
            <Button
                onClick={props.handleOnClick}
                type="primary"
                style={{ float: "right", marginLeft: 8, marginBottom: 16 }}
            >
                <Icon type="plus" />
                Inserir
            </Button>
            <Tooltip title="Exportar para pdf">
                <Button
                    onClick={() => exportList("pdf")}
                    icon="file-pdf"
                    size="default"
                    style={{
                        marginBottom: 16,
                        marginLeft: 8,
                        float: "right",
                        color: "#fa541c",
                    }}
                />
            </Tooltip>
            <Tooltip title="Exportar para excel">
                <Button
                    onClick={() => exportList("xls")}
                    icon="file-excel"
                    size="default"
                    style={{
                        marginBottom: 16,
                        marginLeft: 8,
                        float: "right",
                        color: "#237804",
                    }}
                />
            </Tooltip>
        </Row>
    );
};

export default ButtonsGroup;
